export default "__VITE_ASSET__BTrfhQzQ__"